<template>
  <el-card class="box-card detail-screen">
    <el-row class="title">
      <el-col :span="24">
        {{ $t('transactions.detail_title')}}
        ({{ transaction.id }})
        <span class="is-cancelled" v-if="transaction.is_cancelled || cancelCompleted">{{ $t('transactions.is_cancelled') }}</span>
      </el-col>
    </el-row>
    <el-row class="row-data" align="middle">
      <el-col :span="5"><span class="label">{{ $t('transactions.detail_fields.transaction_datetime') }}</span></el-col>
      <el-col :span="19"><span>{{ $dayjs(transaction.transaction_datetime).format('YY/MM/DD HH:mm') }}</span></el-col>
    </el-row>
    <el-row class="row-data" align="middle" v-if="transaction.type == 2">
      <el-col :span="5"><span class="label">{{ $t('transactions.detail_fields.charge_amount') }}</span></el-col>
      <el-col :span="19"><span>¥{{ transaction.amount_formated}} ({{transaction.point_formated}}ココロン)</span></el-col>
    </el-row>
    <div v-if="transaction.type == 3">
      <el-row class="row-data" align="middle">
          <el-col :span="5"><span class="label">{{ $t('transactions.detail_fields.present') }}</span></el-col>
          <el-col :span="19"><span>{{ presenter }}</span></el-col>
      </el-row>
      <el-row class="row-data border-bottom" align="middle">
          <el-col :span="5"><span class="label">{{ $t('transactions.detail_fields.transaction_kokoron_present') }}</span></el-col>
          <el-col :span="19"><span>{{ transaction.point_formated }}ココロン</span></el-col>
      </el-row>
    </div>
    <div v-if="transaction.type == 1">
        <el-row class="row-data" align="middle">
            <el-col :span="5"><span class="label">{{ $t('transactions.detail_fields.company_name') }}</span></el-col>
            <el-col :span="19"><span>{{ transaction.company.name }}</span></el-col>
        </el-row>
        <el-row class="row-data" align="middle">
            <el-col :span="5"><span class="label">{{ $t('transactions.detail_fields.shop_name') }}</span></el-col>
            <el-col :span="19"><span>{{ transaction.shop.name }}</span></el-col>
        </el-row>
        <el-row class="row-data" align="middle">
            <el-col :span="5"><span class="label">{{ $t('transactions.detail_fields.recipient') }}</span></el-col>
            <el-col :span="19"><span>{{ recipient }}</span></el-col>
        </el-row>
        <el-row class="row-data" align="middle">
            <el-col :span="5"><span class="label">{{ $t('transactions.detail_fields.sender') }}</span></el-col>
            <el-col :span="19"><span>{{ sender }}</span></el-col>
        </el-row>
        <el-row class="row-data border-bottom" align="middle">
            <el-col :span="5"><span class="label">{{ $t('transactions.detail_fields.transaction_kokoron') }}</span></el-col>
            <el-col :span="19"><span>{{ transaction.point_formated }}ココロン  <span v-if="site != $siteType.site_partner">(¥{{ transaction.amount_converted_from_point }})</span></span></el-col>
        </el-row>
    </div>
    <el-row>
      <el-col :span="24" class="text-center mt-40">
        <el-button type="primary"  @click="onClickFormCancel" class="btn btn-edit"
          v-if="transaction.type == 1 && !transaction.is_cancelled && !cancelCompleted && site != $siteType.site_partner">
          {{ $t('transactions.btn_label.cancel') }}
        </el-button>
        <el-button @click="back" class="btn btn-back">{{ $t('transactions.btn_label.back') }}</el-button>
      </el-col>
    </el-row>
  </el-card>
  <dialog-confirm-cancel v-if="isOpenFormCancel"
    :openFormCancel="true"
    @is-close-popup-cancel="handleClosePopupCancel"
    @is-open-noti="handleOpenNoti"
    :transaction="transaction">
  </dialog-confirm-cancel>
  <dialog-cancel-complete
    v-if="isOpenNoti"
    :openNotiCancelComplete="true"
    :transaction="transaction"
    :urls = "urls"
    @is-close-popup-noti="handleClosePopupNoti"
  >
  </dialog-cancel-complete>
</template>
<script>
  export default {
    props: {
      transaction: { type: Object, required: true, default: {} },
      urls: { type: Object, required: true, default: {} },
      site: { type: Number, required: false },
    },
    data() {
      return {
        isOpenFormCancel: false,
        isOpenNoti: false,
        cancelCompleted: false
      }
    },
    methods: {
      formatDate(dateTime) {
        return (dateTime) ? dayjs(dateTime).format('YYYY/MM/DD') : '';
      },

      resetAccount() {
        this.isOpenFormCancel = true;
      },

      back() {
         window.location.href = this.urls.index;
      },

      onClickFormCancel() {
        this.isOpenFormCancel = true;
      },

      handleClosePopupCancel() {
        this.isOpenFormCancel = false;
      },

      handleClosePopupNoti() {
        this.isOpenNoti = false;
      },

      handleOpenNoti() {
        this.isOpenNoti = true;
        this.cancelCompleted = true;
      }
    },
    computed: {
      sender() {
        if (this.transaction.user) {
          let userId = this.site != this.$siteType.site_partner ? '　' + this.transaction.user.id : ''
          return (this.transaction.user.first_name ? this.transaction.user.first_name : '')
            + (this.transaction.user.last_name ? this.transaction.user.last_name : '')
            + ' (' + this.transaction.user.nickname + ') '
            + userId;
        }
        return '';
      },
      recipient() {
        let staffId = this.site != this.$siteType.site_partner ? '　' + this.transaction.staff.id : ''
        if (this.transaction.staff) {
          return this.transaction.staff.name
            + ' (' + this.transaction.staff.nickname + ')'
            + staffId;
        }
        return '';
      },
      presenter() {
        if (this.transaction.user) {
          return (this.transaction.user.first_name ? this.transaction.user.first_name : '')
          + (this.transaction.user.last_name ? this.transaction.user.last_name : '')
            + ' (' + this.transaction.user.nickname + ')';
        }
        return '';
      },
    },
  }
</script>
